import React, {useState} from "react";
import {Avatar, Accordion, AccordionSummary, AccordionDetails, Typography, List, ListItem, ListItemText, ListItemIcon, IconButton, Box, Grid} from "@mui/material";
import ArrowDownIcon from "../../assets/icons/arrowdown.png";
import DocumentIcon from "../../assets/icons/document.png";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment";
import {useNavigate} from "react-router-dom";
import EmptyIcon from "../../assets/images/empty-box.png";


const AnomalyDetectionRecordsComponent = (props) => {

  const {breakpoints, anomalyDetectionList, onClickVisibilityIcon} = props;

  const navigate = useNavigate();

  const [isExpanded, setExpanded] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  }

  const handleVisibilityClick = (e, city) => {
    e.stopPropagation(); 
  }

  const handleOnClickVisibilityIcon = (anomaly) => {
    onClickVisibilityIcon(anomaly);
  }

  return (
    <Box sx={{width: "100%", margin: "0 auto"}}>

      {anomalyDetectionList == 0 && 
        <Box sx={{height: 495, textAlign: "center", flexDirection: "column", 
          justifyContent: "center", display: "flex", alignItems: "center", 
      }}>
          <img alt="empty-data-icon" src={EmptyIcon} width="200" style={{marginTop: "-84px"}} />

          <Typography sx={{color: "#58565f", fontSize: 14, mt: 1}}>
              No data available for the selected date range
          </Typography>
      </Box>
      }

      {anomalyDetectionList != 0 && anomalyDetectionList?.map((anomaly, index) => (
        <Accordion
          key={index}
          expanded={isExpanded === index}
          onChange={handleChange(index)}
          sx={{mb: 2, boxShadow: "none", border: "1px solid #7a78f742", borderRadius: "10px"}}
        >
          <AccordionSummary
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
            sx={{backgroundColor: (isExpanded === index) ? "#7A78F74A" : "#7A78F714",  borderRadius: "10px"}}
            expandIcon={
              ((isExpanded === index) ? 
                <Box sx={{display: "flex", alignItems: "center"}}>
                  <img alt="arrow-down" src={ArrowDownIcon} style={{height: 18, width: 18, transition: "transform 0.3s ease"}} />
                  
                  &nbsp;  
                  
                  <Avatar onClick={(e) => handleVisibilityClick(e, anomaly)}
                    sx={{
                      cursor: "pointer", width: 18, height: 18, backgroundColor: "#5959D8",
                      display: "flex", alignItems: "center", justifyContent: "center"
                    }}
                  >
                    <VisibilityIcon sx={{height: 12}} onClick={()=>handleOnClickVisibilityIcon(anomaly)}/>
                  </Avatar>
                </Box>

              :
                <Box sx={{display: "flex", alignItems: "center"}}>
                  <Avatar onClick={(e) => handleVisibilityClick(e, anomaly)}
                    sx={{
                      cursor: "pointer", width: 18, height: 18, backgroundColor: "#5959D8",
                      display: "flex", alignItems: "center", justifyContent: "center"
                    }}
                  >
                    <VisibilityIcon sx={{height: 12}} onClick={()=>handleOnClickVisibilityIcon(anomaly)}/>
                  </Avatar>

                  &nbsp;

                  <img alt="arrow-down" src={ArrowDownIcon} style={{height: 18, width: 18, transition: "transform 0.3s ease"}} />
                </Box>
              )
            }
          >
            <Typography sx={{fontSize: 16, color: "#3333CF", fontWeight: "bold"}}>
              {anomaly?.city} province of {anomaly?.province} ({anomaly?.count} Anomalies)
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            <List sx={{maxHeight: 280, overflowY: "auto",
              "&::-webkit-scrollbar": {
                width: "8px"
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(217, 217, 217, 0.5)"
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#7a78f7a6",
                borderRadius: "4px"
              },
              "&::-webkit-scrollbar-thumb:hover": {
                  background: "#7A78F7"
              }
            }}>
              {anomaly?.verificationLogs.map((log, i) => (
                <ListItem key={i} divider sx={{borderBottom: "1px solid #7A78F74F", cursor: "pointer"}} onClick={(e) => navigate("/anomaly-detection/details?anomalyId=" + log?.anomaly_id)}>
                  <Grid container>
                    <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                      <ListItemText
                        primary={
                          <Typography sx={{ color: "#58565f", fontSize: 14 }}>
                            {log?.ovi}
                          </Typography>
                        }
                        secondary={
                          <Typography sx={{ color: "#58565f", fontSize: 14 }}>
                            Product: {log?.project_name}
                          </Typography>
                        }
                      />
                    </Grid>

                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                      <ListItemText
                        primary={
                          <Typography sx={{ color: "#58565f", fontSize: 14 }}>
                            {moment(log?.timestamp).format("YYYY-MM-DD hh:mm:ss A")}
                          </Typography>
                        }
                        secondary={
                          <Typography sx={{ color: "#58565f", fontSize: 14 }}>
                            Location: {log?.location}
                          </Typography>
                        }
                      />
                    </Grid>

                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                      <ListItemIcon style={{cursor: "pointer"}}>
                        <IconButton edge="end" style={{cursor: "pointer", marginTop: "16px", marginLeft: "8px", backgroundColor: "transparent", transition: "background-color 0.3s ease"}}>
                          <img alt="document-icon" src={DocumentIcon} style={{height: 30, width: 30, cursor: "pointer"}} />
                        </IconButton>
                      </ListItemIcon>
                    </Grid>
                  </Grid>
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
      
    </Box>
  )
}

export default AnomalyDetectionRecordsComponent
